import { saveInLocalStorage } from '../storage/LocalStorage';
import { createSocketConnection } from './config';
import { createConversation } from '../../state/actions/chats';
import { onGenerateToken, startConversation } from './socketEvents';
import { currentTimeStamp } from '../../utils/moment';
import store from '../../state/configureStore';

export const SOCKET = { socketClient: null }; // Access SOCKET globally

export const initWebSocket = async (params, sessionId, isBotchat) => {
  const botId = params?.botId;

  if (!sessionId) {
    console.error("Missing required user auth info for socket connection.");
    return;
  }

  SOCKET.socketClient = createSocketConnection(sessionId); // Set SOCKET globally
  const socket = SOCKET.socketClient;

  const token = await onGenerateToken(params);
  socket.on('connect', async () => {
    console.info(`%c SOCKET successfully connected for web ${isBotchat ? "(bot)" : ''}`, 'color: green;');

    socket.emit('authenticate-pwa:execute', token, (ack) => {
      console.log('%c Authentication acknowledgment:', 'color: green;', ack, currentTimeStamp());

      if (ack.sessionId && ack.user?.userId && isBotchat) {
        store.dispatch(createConversation(ack.user.userId, botId, params?.userDomain));
        startConversation(ack.user.userId, params);
      }
    });
  });

  // Handle disconnect + attempt reconnect
  socket.on("disconnect", (reason) => {
    console.log("SOCKET disconnected:", reason);
    if (
      sessionId &&
      (
        reason === "transport close" ||
        reason === "ping timeout"
      )
    ) {
      console.log("Attempting reconnect...");
      socket.connect();
    }
  });

  // Socket.io internal reconnect events
  socket.io.on("reconnect_attempt", () => {
    console.info("SOCKET reconnect_attempt");
  });

  socket.io.on("reconnect", () => {
    console.info("SOCKET reconnect");
  });

  socket.on('connect_error', (err) => {
    saveInLocalStorage('thirdPartyEnabled', false);
    console.error('SOCKET connect_error', JSON.stringify(err));
  });

  //Recover when tab is active again
  const handleVisibility = () => {
    if (!document.hidden && sessionId) {
      if (!socket.connected) {
        socket.connect();
      }
    }
  };

  window.addEventListener("focus", handleVisibility);
  document.addEventListener("visibilitychange", handleVisibility);

  return socket;
};